import React from 'react';
import PropTypes from 'prop-types';
import {
  Control,
  LocalForm
} from 'react-redux-form';

import {
  Checkbox,
  FormGroup,
  Row
} from 'react-bootstrap';

const ProfileOptionsComponent = ({
  userConfiguration,
  submitOptions
}) => {

  const initialState = { muteToasts: userConfiguration.muteToasts };

  return (
    <LocalForm
      id={'profile-options-form'}
      model="info"
      initialState={initialState}
      onChange={
        (model) => {
          userConfiguration.muteToasts = model.muteToasts;
          submitOptions(userConfiguration);
        }
      }
    >
      <FormGroup>
        <Row>
          <Control.custom
            component={Checkbox}
            model=".muteToasts"
            style={{ marginLeft: '10px' }}
            mapProps={({ modelValue, onChange }) => {
              return {
                checked: modelValue,
                onChange: c => onChange(c.target.checked)
              };
            }}
          >
            <b>Mute Toasts</b>
            &nbsp;| Will no longer show toasts, but will still be added to the recent list
          </Control.custom>
        </Row>
      </FormGroup>
    </LocalForm>
  );
};

ProfileOptionsComponent.propTypes = {
  userConfiguration: PropTypes.object.isRequired,
  submitOptions: PropTypes.func.isRequired
};

export default ProfileOptionsComponent;


// WEBPACK FOOTER //
// src/Components/ProfileOptionsComponent.jsx